@if (displayToast()) {
  <div id="toast">
    <app-toast
      [toastStyle]="toastStyle()"
      [icon]="toastIcon()"
      [text]="toastMessage()"
    ></app-toast>
  </div>
}
<div id="title--container">
  <h4>All Devices</h4>
</div>
<hr />
<div id="devices--container">
  @if (isFirstLoad()) {
    <div id="loading-spinner">
      <app-loading-spinner label="Fetching devices"></app-loading-spinner>
    </div>
  }
  @if (!isFirstLoad() && error()) {
    <app-error-page primaryText="Failed to load devices"></app-error-page>
  }
  @if (!isFirstLoad() && !error()) {
    <div id="inner-page--container">
      <div id="actions--container">
        <app-search-field
          [field]="searchField"
          [parentForm]="tableControls"
          (buttonClicked)="handleSearch($event)"
        ></app-search-field>
        @if (hasActiveFilters()) {
          <app-icon-button
            label="Clear Filters"
            buttonStyle="transparent--dark-blue"
            buttonId="clear-filters-btn"
            buttonShape="square"
            (buttonClicked)="clearFilters()"
          ></app-icon-button>
        }
        <app-icon-button
          label="filters"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="filter_list"
          buttonShape="square"
          (buttonClicked)="openModal('filter')"
          title="Filters"
        ></app-icon-button>
      </div>
      <div id="table--container">
        <table mat-table [dataSource]="devices()">
          <caption class="sr-only">
            Devices table
          </caption>

          <ng-container matColumnDef="deviceName">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('Name')"
              (keydown.enter)="onSort('Name')"
              (keydown.space)="$event.preventDefault(); onSort('Name')"
              [class.active]="currentSort().sortBy === 'Name'"
              [attr.aria-sort]="
                currentSort().sortBy === 'Name'
                  ? currentSort().sortDirection === 'asc'
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              tabindex="0"
              role="columnheader"
            >
              <span class="sortable">
                Device
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let device">
              <div class="device-name--cell">
                <span>{{ device.name }}</span>
                <span class="device-id">ID: {{ device.id }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="organisation">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('Organisation')"
              (keydown.enter)="onSort('Organisation')"
              (keydown.space)="$event.preventDefault(); onSort('Organisation')"
              [class.active]="currentSort().sortBy === 'Organisation'"
              [attr.aria-sort]="
                currentSort().sortBy === 'Organisation'
                  ? currentSort().sortDirection === 'asc'
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              tabindex="0"
              role="columnheader"
            >
              <span class="sortable">
                Organisation
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let device">
              {{ device.organisationName ?? "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="laboratory">
            <th mat-header-cell *matHeaderCellDef>Laboratory</th>
            <td mat-cell *matCellDef="let device">
              {{ device.laboratoryName ?? "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let device">
              <div class="device-cell--icons">
                <app-status-indicator
                  [status]="DeviceSetupStatus[device.deviceStatusId]"
                  [isOffline]="device.isOffline"
                ></app-status-indicator>
                @if (device.isOffline) {
                  <mat-icon
                    class="error"
                    aria-label="Offline"
                    matTooltip="Offline"
                    >wifi_off</mat-icon
                  >
                } @else {
                  <mat-icon
                    class="positive"
                    aria-label="Online"
                    matTooltip="Online"
                    >wifi</mat-icon
                  >
                }
                <app-software-status-icon
                  [softwareWarning]="device?.softwareWarning"
                />
                @if (device?.isOffline) {
                  <mat-icon
                    class="out-of-sync"
                    aria-label="Device out of sync"
                    matTooltip="Device out of sync"
                    >cloud_off</mat-icon
                  >
                }
                @if (!device?.isOffline) {
                  <mat-icon
                    class="positive"
                    fontSet="material-icons-outlined"
                    aria-label="Device in sync"
                    matTooltip="Device in sync"
                    >cloud</mat-icon
                  >
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="installedModules">
            <th mat-header-cell *matHeaderCellDef>Modules</th>
            <td mat-cell *matCellDef="let device">
              @if (device.installedModules?.length > 0) {
                <app-active-modules
                  [activeModules]="device.installedModules"
                ></app-active-modules>
              } @else {
                <span>-</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="macAddress">
            <th mat-header-cell *matHeaderCellDef>MAC Address</th>
            <td mat-cell *matCellDef="let device">
              {{ device.macAddress ?? "-" }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr *matNoDataRow>
            <td [attr.colspan]="displayedColumns.length" id="empty-state">
              <mat-icon id="empty-state--icon">stream</mat-icon>
              <p id="empty-state--title">No devices found</p>
            </td>
          </tr>
        </table>
        @if (devices().length > 0) {
          <div id="pagination--container">
            <div class="filter--container">
              <label for="devices-per-page">Devices per page</label>
              <app-dropdown-form-field
                id="devices-per-page"
                [field]="devicesPerPageField"
                [parentForm]="tableControls"
              ></app-dropdown-form-field>
            </div>
            <div id="pagination--controls">
              <app-icon-button
                iconName="chevron_left"
                buttonId="previous-btn"
                (buttonClicked)="getPrevious()"
                [isDisabled]="!hasPrevious()"
              ></app-icon-button>
              <span>{{ currentPage() }} / {{ totalPages() }}</span>
              <app-icon-button
                iconName="chevron_right"
                buttonId="next-btn"
                (buttonClicked)="getNext()"
                [isDisabled]="!hasNext()"
              ></app-icon-button>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
<app-filter-modal
  id="filter"
  primaryButtonText="Apply Filters"
  primaryButtonId="continue-button"
  secondaryButtonText="Reset"
  secondaryButtonId="reset-button"
  [modulesField]="moduleFiltersField"
  [deletedField]="includeDeletedField"
  [parentForm]="tableControls"
  [hideDeletedField]="false"
  (modalButtonClicked)="filterModalButtonClicked($event)"
  (moduleCheckboxClicked)="moduleCheckboxClicked($event)"
></app-filter-modal>
